import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const userManagerConfig = {
    authority: process.env.REACT_APP_AUTHORITY,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: `${process.env.REACT_APP_SUPER_WEBAPP_URL}/signin-oidc`,
    response_type: 'code',
    scope: 'openid profile Nexus.API offline_access',
    post_logout_redirect_uri: `${process.env.REACT_APP_SUPER_WEBAPP_URL}/signout-callback-oidc`,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
};

const userManager = new UserManager(userManagerConfig);

const forbiddenReturnTos = ["/signin-oidc", "/signout-callback-oidc"];

const getCurrentReturnTo = () => {
    const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (forbiddenReturnTos.includes(window.location.pathname)) return "/";
    return path;
};

const sanitizeReturnTo = (returnTo) => {
    if (!returnTo || typeof returnTo !== 'string') return '/';
    if (!returnTo.startsWith('/') || returnTo.startsWith('//')) return '/';
    if (forbiddenReturnTos.includes(returnTo.split('?')[0])) return '/';
    return returnTo;
};

export const handleCallback = async () => {
    const user = await userManager.signinCallback();
    return user;
};

export const handleLogoutCallback = async () => {
    // not used
};

export const login = async (returnTo) => {
    const desired = sanitizeReturnTo(returnTo ?? getCurrentReturnTo());
    await userManager.signinRedirect({
        state: { returnTo: desired },
    });
};

export const logout = async () => {
    let user = await userManager.getUser();
    if (user) {
        await userManager.signoutRedirect();
    } else {
        await userManager.signinSilent();
        await userManager.signoutRedirect();
    }
};

export const getUser = async () => {
    try {
        let user = await userManager.getUser();
        if (user) {
            const now = Math.floor(Date.now() / 1000);
            if (user.expires_at > now) {
                return user;
            } else {
                try {
                    user = await userManager.signinSilent();
                    return user;
                } catch (error) {
                    await login();
                }
            }
        } else {
            await login();
        }
    } catch (error) {
        // silent
    }
};
